/* Albert Tusk: "You may also like" Add to Cart.
   Cards are server-rendered by snippets/at-rec-card.liquid (no theme Pre-order logic).
   This file only handles the click: add the variant by AJAX, then refresh + open the cart drawer. */
(() => {
  if (window.__atRecAtc) return;
  window.__atRecAtc = true;

  const ROOT = '[data-at-rec-atc]';
  const ITEM = '[data-at-rec-item]';
  const rootUrl = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function setLabel(btn, text) {
    const l = btn.querySelector('.at-rec-btn__label');
    if (l && text) l.textContent = text;
  }

  function resolveVariant(card) {
    const allowed = (card.dataset.variants || '').split(',').filter(Boolean);
    const input = card.querySelector('input[name="id"], select[name="id"]');
    const picked = input && String(input.value);
    return picked && allowed.includes(picked) ? picked : card.dataset.variantId;
  }

  async function addToCart(root, card) {
    const id = Number(resolveVariant(card));
    const quantity = Math.max(1, parseInt(card.dataset.qtyMin, 10) || 1);
    const base = (root.dataset.cartAddUrl || rootUrl() + 'cart/add').replace(/\.js$/, '');
    const res = await fetch(base + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id, quantity }] })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');
    return data;
  }

  function alpineStore(name) {
    try { return window.Alpine && typeof Alpine.store === 'function' ? Alpine.store(name) : null; }
    catch (e) { return null; }
  }

  // The theme's own header cart toggle (Alpine @click / x-on:click that targets the mini cart)
  function themeCartToggle() {
    return document.querySelector(
      '[\\@click*="xMiniCart"], [x-on\\:click*="xMiniCart"], [\\@click*="openCart"], [x-on\\:click*="openCart"], ' +
      '[data-cart-drawer-toggle], [aria-controls*="cart" i][role="button"], button[aria-controls*="CartDrawer"]'
    );
  }

  async function syncCount() {
    try {
      const cart = await (await fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })).json();
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:not(.visually-hidden)')
        .forEach((el) => { el.textContent = cart.item_count; });
      const helper = alpineStore('xCartHelper');
      if (helper && 'currentItemCount' in helper) helper.currentItemCount = cart.item_count;
    } catch (e) { /* non-critical */ }
  }

  async function openDrawer(root, added) {
    const detail = { source: 'at-rec-atc', items: added && added.items };
    ['eurus:cart:items-changed', 'cart:refresh', 'cart:updated'].forEach((ev) =>
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail }))
    );
    await syncCount();

    const mini = alpineStore('xMiniCart');
    let reloaded = false;
    if (mini && typeof mini.reLoad === 'function') { try { await mini.reLoad(); reloaded = true; } catch (e) {} }
    if (mini && typeof mini.openCart === 'function') { try { mini.openCart(); return; } catch (e) {} }

    const toggle = themeCartToggle();
    if (toggle) { toggle.click(); return; }

    // No drawer on this theme: follow the theme's cart behaviour
    if (!reloaded && root.dataset.cartType === 'page') window.location.href = root.dataset.cartUrl || '/cart';
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(ROOT + ' .at-rec-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    const root = btn.closest(ROOT);
    const card = btn.closest(ITEM);
    const label = root.dataset.label || 'Add to Cart';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      const added = await addToCart(root, card);
      btn.classList.remove('is-loading');
      setLabel(btn, root.dataset.labelAdded || 'Added');
      await openDrawer(root, added);
    } catch (err) {
      btn.classList.remove('is-loading');
      setLabel(btn, String(err.message || 'Error').slice(0, 40));
    } finally {
      btn.removeAttribute('aria-busy');
      setTimeout(() => setLabel(btn, label), 1800);
    }
  }, true);
  /* ---------- wishlist hearts (shared with card-product-premium.js, key "pc:wishlist") ---------- */
  const WISH_KEY = 'pc:wishlist';
  const readWish = () => { try { const a = JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } };

  function syncHearts() {
    const list = readWish();
    document.querySelectorAll(ROOT + ' [data-pc-wish]').forEach((b) => {
      const on = list.includes(b.getAttribute('data-product-handle')) ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
  }

  // Fallback only if the premium runtime is not on the page
  document.addEventListener('click', (e) => {
    const b = e.target.closest(ROOT + ' [data-pc-wish]');
    if (!b || window.__pcRuntime || window.__pcCardInit) return;
    e.preventDefault();
    const h = b.getAttribute('data-product-handle');
    const list = readWish();
    const i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) {}
    document.querySelectorAll('[data-pc-wish-count]').forEach((el) => {
      el.textContent = String(list.length);
      if (list.length) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    syncHearts();
  });

  // Cards arrive by AJAX: keep heart state in sync
  let q = false;
  new MutationObserver((recs) => {
    if (q || !recs.some((r) => r.addedNodes.length)) return;
    q = true;
    requestAnimationFrame(() => { q = false; syncHearts(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', (e) => { if (e.key === WISH_KEY) syncHearts(); });
  document.addEventListener('pc:wishlist', syncHearts);
  syncHearts();
})();